import { Button, Heading, Typography } from '@/shared/ui';

interface ConfirmModalProps {
  onConfirm?: () => void;
  onCancel?: () => void;
}
export const ResetModal = ({ onConfirm, onCancel }: ConfirmModalProps) => {
  return (
    <div className="flex flex-col pt-10">
      <div className="flex flex-col gap-y-3 px-5">
        <Heading variant="s">
          Are you sure you want to Cancel the changes?
        </Heading>
        <Typography variant="14-r" color="base-300" className="text-center">
          The changes you have made will&nbsp;be&nbsp;reset
        </Typography>
      </div>
      <div className="flex flex-col gap-y-1 pb-1 pt-7">
        <Button variant="contrast-500" size="d-l" onClick={onConfirm}>
          Yes, cancel
        </Button>
        <Button variant="surface-01" size="d-l" onClick={onCancel}>
          No, back
        </Button>
      </div>
    </div>
  );
};
